import * as z from "zod";

export const ShopperAgentChannelConfigSchema = z.object({
  enabled: z.boolean().optional(),
});

export type ShopperAgentChannelConfig = z.infer<
  typeof ShopperAgentChannelConfigSchema
>;

export const ShopperAgentChannelsConfigSchema = z.object({
  sms: ShopperAgentChannelConfigSchema.optional(),
  email: ShopperAgentChannelConfigSchema.optional(),
});

export type ShopperAgentChannelsConfig = z.infer<
  typeof ShopperAgentChannelsConfigSchema
>;
